export const LIB_VERSION = '18.1.0'; // autogenerated
//# sourceMappingURL=version.js.map